// extracted by mini-css-extract-plugin
module.exports = {"menu":"Sider_menu__1dvqa"};